import { useState } from "react";
import {
  useTargetCollaborationGroupDetail,
  useTargetCollaborationGroupInsightsFunnel,
  useTargetCollaborationGroupInsightsPerformance,
  useTargetCollaborationGroupInsightsRelationships,
  useTargetCollaborationGroupInsightsSummary,
} from "@/api/collaborations";
import type { CreatorStatusTab } from "../collaboration-table-columns";
import { CollaborationInsightsPanelView } from "./collaboration-insights-panel-view";

type Props = {
  groupId: string | undefined;
  showRecommendations?: boolean;
  onFilterChange?: (status: CreatorStatusTab) => void;
  onBreakdownFilterChange?: (bucket: string | null) => void;
};

export function GroupCollaborationInsightsPanel({
  groupId,
  showRecommendations,
  onFilterChange,
  onBreakdownFilterChange,
}: Props) {
  const [performanceMode, setPerformanceMode] = useState<"invited" | "accepted">("accepted");

  // Only used to resolve a single concrete collaborationId for the
  // "Find More Creators" recommendations link, which needs one.
  const groupDetailQuery = useTargetCollaborationGroupDetail(groupId);
  const recommendationsCollaborationId = groupDetailQuery.data?.collaborationIds[0];

  const summaryQuery = useTargetCollaborationGroupInsightsSummary(groupId);
  const funnelQuery = useTargetCollaborationGroupInsightsFunnel(groupId);
  const relationshipsQuery = useTargetCollaborationGroupInsightsRelationships(groupId);
  const performanceQuery = useTargetCollaborationGroupInsightsPerformance(groupId, performanceMode);

  return (
    <CollaborationInsightsPanelView
      summaryQuery={summaryQuery}
      funnelQuery={funnelQuery}
      relationshipsQuery={relationshipsQuery}
      performanceQuery={performanceQuery}
      recommendationsCollaborationId={recommendationsCollaborationId}
      collaborationType="target"
      showRecommendations={showRecommendations}
      showModeToggle
      performanceMode={performanceMode}
      onPerformanceModeChange={setPerformanceMode}
      onFilterChange={onFilterChange}
      onBreakdownFilterChange={onBreakdownFilterChange}
    />
  );
}
